class Node {
  value: string;
  children: Node[];
  is_word?: boolean;

  constructor(char: string) {
    this.value = char;
    this.children = [];
  }
}

export default class Trie {
  root: Node;

  constructor(data: string[]) {
    this.root = new Node("");

    for (let i = 0; i < data.length; ++i) {
      const word = data[i];
      let node = this.root;
      for (let j = 0; j < word.length; ++j) {
        const char = word[j];
        const childNode = node.children.find((n) => n.value === char);
        if (childNode) {
          node = childNode;
        } else {
          const new_node = new Node(char);
          node.children.push(new_node);
          node = new_node;
        }
      }
      node.is_word = true;
    }
  }

  suggestions(chars: string): string[] {
    let node = this.root;
    let prefix = "";
    for (let i = 0; i < chars.length; ++i) {
      let child = node.children.find((n) => n.value === chars[i]);
      if (!child) {
        const alternativeChar = chars[i] === chars[i].toLowerCase()
          ? chars[i].toUpperCase()
          : chars[i].toLowerCase();
        child = node.children.find((n) => n.value === alternativeChar);
      }

      if (!child) break;
      node = child;
      prefix += node.value;
    }

    const result: string[] = [];
    if (node.is_word) result.push(prefix);

    let stack: Node[] = node.children.slice();
    let wstack: string[] = node.children.map(() => prefix);

    while (stack.length) {
      const n = stack.pop();
      const w = wstack.pop();
      if (n && w !== undefined) {
        const newWord = w + n.value;
        if (n.is_word) {
          result.push(newWord);
        }
        stack = stack.concat(n.children);
        wstack = wstack.concat(n.children.map(() => newWord));
      }
    }
    return result;
  }
}
